module.exports = __webpack_public_path__ + "img/T_and_C.f2454121.png";